import styled from 'styled-components'

import { Separator } from '@blade/ui-kit'

export const SeparatorVertical = styled(Separator)`
  background: var(--background-4);
  border-radius: 2px;

  height: 11px;
`
